exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-gray[data-v-1cd06d82]{-webkit-filter:invert(0.5);filter:invert(0.5)}\n", ""]);

// exports
